import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; // Assure-toi d'avoir framer-motion installé
import CV from '../assets/doc/CV_ML.pdf';
import GitHubActivity from '../components/GitHubActivity';
import { LanguageContext } from '../context/LanguageContext';

const Home = () => {
  const { t } = useContext(LanguageContext);

  return (
    <div className="min-h-screen bg-[#f8fafc] selection:bg-indigo-100">
      <div className="flex items-center py-20 pt-48 pb-32">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-16">
            
            {/* Section texte */}
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="flex-[1.5] space-y-10 text-center lg:text-left"
            >
              <div className="space-y-4">
                <span className="inline-block px-4 py-1.5 text-sm font-bold tracking-widest text-indigo-600 bg-indigo-50 rounded-full uppercase">
                  {t('role')}
                </span>
                <h1 className="text-5xl md:text-7xl font-black text-slate-900 leading-tight tracking-tight">
                  Maxime London <span className="text-indigo-600">NJO</span>
                </h1>
              </div>
              
              <div className="space-y-6 text-lg md:text-xl text-slate-600 leading-relaxed max-w-2xl">
                <p className="font-medium text-slate-800">
                  {t('greeting')}
                </p>
                <p className="opacity-80">
                  {t('description')}
                </p>
              </div>
              
              {/* Boutons stylisés */}
              <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start items-center">
                <a
                  href={CV}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full sm:w-auto px-10 py-4 bg-slate-900 text-white font-bold rounded-2xl shadow-xl hover:bg-indigo-600 hover:-translate-y-1 transition-all duration-300"
                >
                  {t('cv')}
                </a>
                <Link
                  to="/contact"
                  className="w-full sm:w-auto px-10 py-4 bg-white text-slate-900 font-bold rounded-2xl border-2 border-slate-200 hover:border-indigo-600 hover:text-indigo-600 hover:-translate-y-1 transition-all duration-300 shadow-sm"
                >
                  {t('contactMe')}
                </Link>
              </div>
            </motion.div>

            {/* Section Visuelle Abstraite (Remplace la photo) */}
            <motion.div 
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
              className="flex-1 relative hidden lg:flex justify-center"
            >
              {/* Un carré graphique moderne et "safe" pour un pudique */}
              <div className="relative w-80 h-80">
                <div className="absolute inset-0 bg-gradient-to-tr from-indigo-600 to-blue-400 rounded-3xl rotate-6 opacity-20 animate-pulse" />
                <div className="absolute inset-0 bg-white border-2 border-slate-100 rounded-3xl shadow-2xl flex items-center justify-center overflow-hidden">
                  <div className="p-8 space-y-4 w-full font-mono text-sm text-indigo-300">
                    <div className="h-2 w-20 bg-indigo-100 rounded" />
                    <div className="h-2 w-32 bg-indigo-50 rounded" />
                    <div className="h-2 w-24 bg-indigo-100 rounded" />
                    <div className="h-2 w-16 bg-indigo-50 rounded" />
                    <div className="pt-4 flex gap-2">
                       <div className="w-3 h-3 rounded-full bg-red-400/30" />
                       <div className="w-3 h-3 rounded-full bg-yellow-400/30" />
                       <div className="w-3 h-3 rounded-full bg-green-400/30" />
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      
      {/* Section GitHub Activity avec fond léger */}
      <div className="bg-white border-y border-slate-100 py-24">
        <div className="max-w-6xl mx-auto px-6">
          <div className="mb-10 text-center lg:text-left">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">Open Source</h3>
            <p className="text-slate-500">Mon activité récente sur GitHub</p>
          </div>
          <GitHubActivity />
        </div>
      </div>
    </div>
  );
};

export default Home;